<template>
  <div>
    <p>{{ $t("节点配置") }}</p>
    <t-form-item name="tip" :rules="requireRule">
      <template #label>
        <text-with-mark :text="$t('引导话术')" />
      </template>
      <t-input
        v-model="formData.tip"
        maxlength="200"
        :placeholder="$t('例如：请填写资料，以便我们更好地提供服务')"
      />
    </t-form-item>

    <div v-for="(item, index) in formData.inputVariables" :key="index">
      <t-form-item>
        <template v-if="index === 0" #label>
          <div class="collapseLabel">
            <div>
              <span>{{ $t("信息配置") }}</span>
              <span style="color: #d54941; padding-left: 3px">*</span>
            </div>
            <div>
              <t-button
                variant="text"
                theme="primary"
                style="padding-right: 0; margin-right: 10px"
                @click="collapseAll"
              >
                {{ $t("收起全部") }}
              </t-button>
              <t-button
                variant="text"
                theme="primary"
                style="padding-right: 0"
                @click="expandAll"
                >{{ $t("展开全部") }}</t-button
              >
            </div>
          </div>
        </template>
        <t-collapse :value="expandItems" borderless @change="handlePanelChange">
          <t-collapse-panel
            :value="`${index}`"
            :header="$t('信息') + ' ' + (index + 1)"
          >
            <template #headerRightContent>
              <CloseCircleIcon
                :disabled="formData.inputVariables.length <= 1"
                size="16"
                style="padding-left: 8px; vertical-align: sub"
                @click="deleteInfo(index)"
              />
            </template>

            <t-form-item
              :name="`inputVariables[${index}].variableKey`"
              :status-icon="false"
            >
              <template #label>
                <span style="color: #6d778c">{{ $t("添加到变量") }}</span>
              </template>
              <select-with-operate
                v-model="formData.inputVariables[index].variableKey"
              />
            </t-form-item>
            <t-form-item
              :name="`inputVariables[${index}].isRequired`"
              :status-icon="false"
            >
              <t-checkbox
                :checked="formData.inputVariables[index].isRequired === 1"
                @change="handleRequiredChange(index, $event)"
                >{{ $t("设为必填") }}</t-checkbox
              >
            </t-form-item>
            <t-divider style="margin: 8px 0" />
            <t-form-item
              :name="`inputVariables[${index}].formType`"
              :status-icon="false"
              :rules="requireRule"
              :required-mark="false"
            >
              <template #label>
                <text-with-mark :text="$t('收集方式')" />
              </template>
              <t-radio-group
                :value="formData.inputVariables[index].formType"
                @change="onTypeChange(index, $event)"
              >
                <t-radio :value="1">{{ $t("选项") }}</t-radio>
                <t-radio :value="0">{{ $t("输入") }}</t-radio>
              </t-radio-group>
            </t-form-item>
            <t-form-item
              :name="`inputVariables[${index}].name`"
              :status-icon="false"
              :rules="requireRule"
              :required-mark="false"
              style="padding-bottom: 10px"
            >
              <template #label>
                <text-with-mark :text="$t('标题')" />
              </template>
              <t-input
                v-model="formData.inputVariables[index].name"
                maxlength="50"
              />
            </t-form-item>
            <div v-if="formData.inputVariables[index].formType === 0">
              <t-form-item
                :name="`inputVariables[${index}].placeholder`"
                :status-icon="false"
                :rules="requireRule"
                :required-mark="false"
                style="padding-bottom: 10px"
              >
                <template #label>
                  <text-with-mark :text="$t('提示文案')" />
                </template>
                <t-input
                  v-model="formData.inputVariables[index].placeholder"
                  maxlength="50"
                />
              </t-form-item>
            </div>
            <div v-if="formData.inputVariables[index].formType === 1">
              <div
                v-for="(chooseItem, itemIndex) in formData.inputVariables[
                  index
                ]['chooseItemList']"
                :key="itemIndex"
                style="padding: 0px 24px 20px 0"
              >
                <t-form-item
                  :name="`inputVariables[${index}].chooseItemList[${itemIndex}]`"
                  :rules="requireRule"
                  :required-mark="false"
                >
                  <template v-if="itemIndex === 0" #label>
                    <text-with-mark :text="$t('选项')" />
                  </template>
                  <t-space>
                    <t-input
                      v-model="
                        (formData.inputVariables[index]['chooseItemList'] ??
                          [])[itemIndex]
                      "
                      maxlength="200"
                      style="width: 345px"
                    />
                    <CloseCircleIcon
                      size="16"
                      style="cursor: pointer"
                      @click="deleteChooseItem(index, itemIndex)"
                    />
                  </t-space>
                </t-form-item>
              </div>
              <t-form-item
                v-if="
                  (formData.inputVariables[index]['chooseItemList'] ?? [])
                    .length < 10
                "
                :status-icon="false"
              >
                <t-space size="small">
                  <t-link
                    theme="primary"
                    hover="color"
                    @click="addChooseItem(index)"
                    >{{ $t("添加选项") }}</t-link
                  >
                </t-space>
              </t-form-item>
            </div>
          </t-collapse-panel>
        </t-collapse>
      </t-form-item>
    </div>
    <t-form-item
      v-if="formData.inputVariables.length < 10"
      :status-icon="false"
    >
      <t-space size="small">
        <t-link theme="primary" hover="color" @click="addInfo">{{
          $t("添加信息")
        }}</t-link>
      </t-space>
    </t-form-item>
    <t-form-item
      name="inputVariables"
      :rules="infoListRules"
      label-width="0"
      :status-icon="false"
    >
    </t-form-item>
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref, watch } from "vue";
import { CloseCircleIcon } from "tdesign-icons-vue-next";
import { map, trim } from "lodash-es";
import { t } from "@/utils/i18n";

const emit = defineEmits(["updateData"]);

type InputVariablesProp = Array<{
  type: "string"; // 为了以后的扩展性考虑，先默认填成string
  name: string;
  placeholder?: string;
  isRequired: 1 | 0; // 1:必填, 0非必填
  variableKey: string; // 从变量列表拉取，再选择
  formType: 0 | 1; // 输入方式 0代表输入，1代表选择
  chooseItemList?: string[];
}>;

const props = defineProps<{
  data: {
    inputVariables: InputVariablesProp;
    tip: string;
  };
}>();

type Model = {
  nodeData: {
    inputVariables: InputVariablesProp;
    tip: string;
  };
};

const formData = reactive<Model["nodeData"]>({
  inputVariables: props.data.inputVariables ?? [],
  tip: props.data.tip ?? "",
});

const expandItems = ref(["0"]);

const handlePanelChange = (val) => {
  expandItems.value = val;
};

const collapseAll = () => {
  expandItems.value = [];
};

const expandAll = () => {
  expandItems.value = map(formData.inputVariables, (v, index) => {
    return `${index}`;
  });
};

const infoListRules = [
  {
    message: t("不能为空"),
    validator(v) {
      console.log("v", v);
      return v.length >= 1;
    },
  },
];

const requireRule = [
  {
    validator: (str) => {
      return !!trim(str);
    },
    message: t("不能为空"),
    trigger: "change",
  },
];

const addInfo = () => {
  formData.inputVariables.push({
    type: "string",
    name: "",
    placeholder: "",
    isRequired: 0, // 1:必填, 0非必填
    variableKey: "", // 从变量列表拉取，再选择
    formType: 1,
    chooseItemList: [""],
  });
};

const deleteInfo = (index: number) => {
  if (formData.inputVariables.length <= 1) return;
  formData.inputVariables.splice(index, 1);
};

const deleteChooseItem = (index: number, itemIndex: number) => {
  if ((formData.inputVariables[index].chooseItemList ?? []).length <= 1) return;
  formData.inputVariables[index].chooseItemList?.splice(itemIndex, 1);
};

const addChooseItem = (index: number) => {
  formData.inputVariables[index].chooseItemList?.push("");
};

const handleRequiredChange = (index, checked) => {
  formData.inputVariables[index].isRequired = checked ? 1 : 0;
};

const onTypeChange = (index, value) => {
  formData.inputVariables[index].formType = value;
  if (!value && !formData.inputVariables[index].chooseItemList?.length)
    formData.inputVariables[index].chooseItemList = [""];
};

watch(formData, (newVal, oldVal) => {
  emit("updateData", newVal);
});
</script>
<style lang="less" scoped>
:deep(.flow-t-collapse.flow-t--border-less) {
  width: 100%;
}
:deep(.flow-t-collapse-panel__wrapper) {
  background-color: #f9fafc;
  margin-bottom: 15px;
  border-radius: 8px;
  border: 1px solid #e4e8ee;
  :deep(.flow-t-collapse-panel__header) {
    padding-left: 0px !important;
  }
}
:deep(.flow-t-button--variant-text:hover) {
  border-color: transparent;
  background-color: transparent;
}
:deep(.flow-t-collapse-panel__wrapper .flow-t-collapse-panel__content) {
  padding-left: 16px;
  padding-top: 0px;
}
:deep(.flow-t-collapse.flow-t--border-less .flow-t-collapse-panel__body) {
  background-color: #f9fafc;
}
.marginBtm {
  margin-bottom: 8px;
}
:deep(.flow-t-form__label) {
  padding-right: 0px;
}
:deep(.flow-t-form__controls .flow-t-form__item) {
  margin-right: 0px;
}
.collapseLabel {
  display: flex;
  justify-content: space-between;
}
</style>
